import { Link } from "react-router-dom";
import { ShieldCheck, BellRing, CalendarClock } from "lucide-react";

export const AuthLayout = ({ children }) => {
  return (
    <div className="min-h-screen bg-background auth-wash relative">
      <div className="noise absolute inset-0" aria-hidden="true" />
      <div className="relative mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 flex min-h-screen">
        <div className="hidden lg:flex w-1/2 flex-col justify-center pr-16">
          <Link to="/login" className="font-heading text-3xl font-bold tracking-tight" data-testid="auth-brand-link">
            BIIPP
          </Link>
          <p className="mt-6 text-2xl font-heading font-medium leading-snug text-foreground/90">
            Calm, reliable reminders for everything that expires.
          </p>
          <p className="mt-4 text-muted-foreground leading-relaxed max-w-md">
            Track permits, policies, licenses, registrations and more — and get reminded before renewal is due, not after.
          </p>
          <div className="mt-10 space-y-4 text-sm text-muted-foreground">
            <div className="flex items-center gap-3">
              <CalendarClock className="h-4 w-4 text-[hsl(var(--status-upcoming))]" />
              <span>One dashboard for every renewal date</span>
            </div>
            <div className="flex items-center gap-3">
              <BellRing className="h-4 w-4 text-[hsl(var(--status-due-soon))]" />
              <span>Email reminders before anything falls due</span>
            </div>
            <div className="flex items-center gap-3">
              <ShieldCheck className="h-4 w-4 text-[hsl(var(--status-ok))]" />
              <span>Your organization's data stays strictly yours</span>
            </div>
          </div>
        </div>
        <div className="flex w-full lg:w-1/2 items-center justify-center py-10">
          <div className="w-full max-w-md animate-fade-up">
            <div className="lg:hidden mb-8 text-center">
              <Link to="/login" className="font-heading text-2xl font-bold tracking-tight">BIIPP</Link>
            </div>
            {children}
            <p className="mt-8 text-center text-xs text-muted-foreground/80">
              <Link to="/privacy" className="hover:text-foreground transition-colors">Privacy</Link>
              <span className="mx-2">·</span>
              <Link to="/terms" className="hover:text-foreground transition-colors">Terms</Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
